module.exports = __webpack_public_path__ + "img/swiper-item2.dfcb55bd.png";